import { NgModule } from '@angular/core';
import {
  MatAutocompleteModule, MatCardModule,
  MatCheckboxModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule, MatInputModule,
  MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule,
  MatSlideToggleModule, MatSortModule,
  MatTableModule, MatTooltipModule
} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ArchwizardModule} from 'angular-archwizard';
import {Ng5SliderModule} from 'ng5-slider';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MatCurrencyFormatModule} from "mat-currency-format";
import {ChartsModule} from "ng2-charts";


@NgModule({
  declarations: [],
  imports: [
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSortModule,
    ArchwizardModule,
    Ng5SliderModule,
    PdfViewerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatCardModule,
    MatCurrencyFormatModule,
    ChartsModule
  ],
  exports: [
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSortModule,
    ArchwizardModule,
    Ng5SliderModule,
    PdfViewerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatCardModule,
    MatCurrencyFormatModule,
    ChartsModule
  ]
})
export class ContrackCommonModule { }
